import "./VerifyAccountSecurity.css";
import { storeUser } from "../../../../redux/users/usersSlice";
import { toastify } from "../../../../helpers/toast/toastify";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import FloatingDropdownWithArrow from "../../../sharedPages/CommonComponents/FloatingDropdownWithArrow/FloatingDropdownWithArrow";
import { fetchUser } from "../../../../helpers/helper";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";

const AccountSecurity = () => {
  const api = useApi();
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user?.user);

  const [isChanged, setIsChanged] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [security, setSecurity] = useState({});
  const [selectedOptionForLogout, setSelectedOptionForLogout] = useState("");
  const [selectedOptionForOtp, setSelectedOptionForOtp] = useState("");

  const options = ["Yes", "No"];

  const save = async () => {
    const logout = selectedOptionForLogout === "Yes" ? true : false;
    const otp = selectedOptionForOtp === "Yes" ? true : false;

    let payload = {
      security: {
        ...security,
        logout,
        otp,
      },
    };

    const response = await api("post", "users/updateAccountSettings", {
      ...payload,
    });
    if (response?.status) {
      toastify("Account security settings is updated.", "success");

      await fetchUser(api, dispatch, storeUser);

      localStorage.setItem("token", response?.data?.token);
      setIsLoading(false);
    } else {
      setIsLoading(false);
      toastify(response?.message);
    }
  };

  useEffect(() => {
    setSecurity(user?.security);
    setSelectedOptionForLogout(user?.security?.logout ? "Yes" : "No");
    setSelectedOptionForOtp(user?.security?.otp ? "Yes" : "No");
  }, [user]);

  const logout = selectedOptionForLogout === "Yes" ? true : false;
  const otp = selectedOptionForOtp === "Yes" ? true : false;

  useEffect(() => {
    if (security.logout !== logout || security.otp !== otp) setIsChanged(true);
    else setIsChanged(false);
  }, [security, selectedOptionForLogout, selectedOptionForOtp]);

  return (
    <>
      <div className="accountSecrityBox">
        <div className="headingBox">
          <h2 className="title">Account Security</h2>
        </div>
        <div className="securityInputsRow">
          <div className={`securityField ${security.otp === otp ? "activeFadeText" : ""}`}>
            <FloatingDropdownWithArrow
              id="otp"
              label="One time password on login"
              options={options}
              selectedValue={selectedOptionForOtp}
              setSelectedValue={setSelectedOptionForOtp}
              showLabelAnimation={true}
            />
          </div>
          <div className={`securityField ${security.logout === logout ? "activeFadeText" : ""}`}>
            <FloatingDropdownWithArrow
              id="inactivity"
              label="Log out after 15 minutes inactivity?"
              options={options}
              selectedValue={selectedOptionForLogout}
              setSelectedValue={setSelectedOptionForLogout}
              showLabelAnimation={true}
            />
          </div>
        </div>
        {isChanged && (
          <div className="d-flex justify-content-end align-items-center">
            <BubbleSvgButton
              text="Save edits"
              type="button"
              variant="black"
              containerStyling={{ justifyContent: "center" }}
              onClick={() => { setIsLoading(true); save(); }}
              disabled={isLoading}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default AccountSecurity;
